// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3cj94","location":"Header_location__1SLdT"};